import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot instead of render
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';

const root = createRoot(document.getElementById('root')); // Use createRoot instead of render
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);